import { render, staticRenderFns } from "./SandboxStep.vue?vue&type=template&id=5af33f22&"
import script from "./SandboxStep.vue?vue&type=script&lang=js&"
export * from "./SandboxStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5af33f22')) {
      api.createRecord('5af33f22', component.options)
    } else {
      api.reload('5af33f22', component.options)
    }
    module.hot.accept("./SandboxStep.vue?vue&type=template&id=5af33f22&", function () {
      api.rerender('5af33f22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/onboardingShell/steps/SandboxStep.vue"
export default component.exports